import { TreeNode } from './tree-node';

export class ContainerNode<TContainer, TLeaf> extends TreeNode<TContainer, TLeaf> {
  constructor(
    public data: TContainer,
    public children: TreeNode<TContainer, TLeaf>[] = []
  ) {
    super();
  }

  readonly kind = 'container' as const;
}
